'use client';

import { ListSVG, MainMenuSVG } from '@sbercloud/uikit-product-icons';
import { MobileDroplist } from '@sbercloud/uikit-product-mobile-dropdown';
import { ButtonFunction } from '@snack-uikit/button';
import { ItemId } from '@snack-uikit/list';
import cn from 'classnames';

import { Condition, SidebarMenu, TableOfContent } from '@/components/static';
import { usePageNavigationCtx } from '@/hooks/ctx';
import { useCurrentLinkText } from '@/hooks/navigation';
import { Predicate } from '@/types/common';
import { isEmpty } from '@/utils/common';

import s from './styles.module.scss';
import { PageNavigationProps } from './types';
import { getTOCLabel } from './utils';

export function NavPanel({
  TOCList,
  rootClassName,
  anchor,
  getActiveElementParentIdsPred,
}: PageNavigationProps & { anchor: string; getActiveElementParentIdsPred?: Predicate<ItemId[]> }) {
  const { rootFolderSlug, sidebarHtmlString, sidebarTitleData } = usePageNavigationCtx();
  const TOCLabel = getTOCLabel(anchor);
  const currentLinkText = useCurrentLinkText(rootFolderSlug, sidebarHtmlString);

  return (
    <div className={cn(s.tabs_wrapper, rootClassName)}>
      <div className={s.tabs_content_wrapper_mobile}>
        <Condition when={Boolean(sidebarHtmlString && sidebarTitleData && rootFolderSlug)} otherwise={<div />}>
          <MobileDroplist items={[{ content: <SidebarMenu /> }]}>
            <ButtonFunction
              className={s.TOC_controls}
              size='m'
              icon={<MainMenuSVG />}
              iconPosition='before'
              // @ts-ignore
              label={
                <div
                  className={cn(s.mobile_TOC_active_element, {
                    [s.single_mobile_TOC_active_element]: isEmpty(TOCLabel),
                  })}
                >
                  {currentLinkText}
                </div>
              }
            />
          </MobileDroplist>
        </Condition>
        <Condition when={!isEmpty(TOCList)}>
          <MobileDroplist
            items={[
              {
                content: (
                  <TableOfContent getActiveElementParentIdsPred={getActiveElementParentIdsPred} customList={TOCList} />
                ),
              },
            ]}
          >
            <ButtonFunction
              size='m'
              className={s.TOC_controls}
              icon={<ListSVG />}
              iconPosition='after'
              // @ts-ignore
              label={
                <div
                  className={cn(s.mobile_TOC_active_element, {
                    [s.single_mobile_TOC_active_element]: isEmpty(currentLinkText),
                  })}
                >
                  {TOCLabel}
                </div>
              }
            />
          </MobileDroplist>
        </Condition>
      </div>
    </div>
  );
}
